import Tabs, { TabsProps } from '@material-ui/core/Tabs';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    height: 44,
    color: theme.customProps.tabs.textColor,
    backgroundColor: theme.customProps.tabs.backgroundColor,
    borderBottom: theme.customProps.tabs.bottomBorder,

    '& .MuiTab-root': {
      fontSize: 14,
      textTransform: 'none',
    },
    '& .MuiButtonBase-root': {
      zIndex: 1,
    },
  },
  indicator: {
    display: 'flex',
    height: '100%',
    backgroundColor: theme.customProps.tabs.activeBackgroundColor,
    color: theme.customProps.tabs.selectedTextColor,
  },
}));

export const NkTabs = (props: TabsProps): JSX.Element => {
  const classes = useStyles();
  return (
    <Tabs {...props} classes={{ ...props.classes, ...classes }}>
      {props.children}
    </Tabs>
  );
};
